<div class="relative">
  <textarea [id]="id" class="global-textarea peer" [formControl]="options.control"
    [placeholder]="options.label|translate" rows="3"></textarea>

  <label [for]="id" class="floating-label" [translate]="options.label" [ngClass]="{'required':isRequired }">

  </label>
</div>

<!-- <span class="text-red-500">Field Is Required</span> -->



@if(options.isShowErrors) {

<span class="text-red-500 block" *ngIf="options.control?.errors?.['required']"
  translate="This field is required"></span>

<span class="text-red-500 block" *ngIf="options.control?.errors?.['maxlength'] ">{{'The maximum number of characters
  is'|translate}}
  {{options.control?.errors?.['maxlength']?.requiredLength}}</span>
<span class="text-red-500 block" *ngIf="options.control?.errors?.['minlength'] ">{{'The minimum number of characters
  is'|translate}}
  {{options.control?.errors?.['minlength']?.requiredLength}}</span>




}